var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthcare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 111.571,
    viewBox: "0 0 120 111.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.194,
    y1: 0.21,
    x2: 1.22,
    y2: 1.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_metro-heartbeat",
    x: 0,
    y: 0,
    width: 120,
    height: 111.571,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_metro-heartbeat)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-heartbeat-2",
    "data-name": "Icon metro-heartbeat",
    d: "M44.713,33.907H54.755a3.343,3.343,0,0,1-.329.346q-.165.148-.3.247l-.1.132L33.519,54.385a2.067,2.067,0,0,1-2.9,0L10.077,34.565a3.109,3.109,0,0,1-.691-.659H21.535a2.074,2.074,0,0,0,1.3-.444,1.977,1.977,0,0,0,.741-1.136l2.3-9.252,6.256,21.96a2.1,2.1,0,0,0,.757,1.086,2.057,2.057,0,0,0,1.284.428,2.009,2.009,0,0,0,1.251-.428,2.1,2.1,0,0,0,.757-1.086l4.807-15.968,1.844,3.687a1.972,1.972,0,0,0,1.877,1.152ZM61.57,19.815a17.9,17.9,0,0,1-3.391,9.877H46.03l-3.655-7.276a1.986,1.986,0,0,0-.839-.889,2.1,2.1,0,0,0-3.046,1.251L34.244,36.936,27.79,14.35a2.067,2.067,0,0,0-.774-1.086,2.126,2.126,0,0,0-1.3-.428,2.058,2.058,0,0,0-2.008,1.58L19.889,29.692H5.962a17.9,17.9,0,0,1-3.391-9.877q0-7.243,4.181-11.326T18.308,4.407a13.123,13.123,0,0,1,4.165.708,16.858,16.858,0,0,1,3.951,1.91q1.827,1.2,3.144,2.255a30.364,30.364,0,0,1,2.5,2.239,30.325,30.325,0,0,1,2.5-2.239q1.317-1.054,3.144-2.255a16.855,16.855,0,0,1,3.951-1.91,13.123,13.123,0,0,1,4.165-.708q7.375,0,11.556,4.083T61.57,19.815Z",
    transform: "translate(22.93 21.09)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.6203ac04220b597ecb3e26913867e796.svg";
export { ForwardRef as ReactComponent };